module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("The root of a fine digital art piece on any substrate is the photograph. Combining two or more photographs by layering or digitally fusing them using a photo-editing program can result in unique and highly expressive images for printing.")]), _vm._v(" "), _c('p', {
    staticClass: "ChapTitle",
    attrs: {
      "id": "toc1"
    }
  }, [_vm._v("TAKING PHOTOS")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("The more photographs you have to choose from, the better. The more photographs you take, the more likely you’ll get some winners!")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("I used to carry a large, heavy SLR (single-lens reflex) camera around with me everywhere. Years later, I took a point-and-shoot camera.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Today, my cell phone is with me all the time. When you print on cloth and other substrates, you really don’t need a large-megapixel camera. While professional cameras have superior technical capabilities, the quality of any photo depends on the photographer’s intent and creative vision.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Current movements using smartphone photography (sometimes referred to as “iPhoneography”) extol the virtues of the immediacy and convenience of cell phone cameras. Take your camera/phone far and wide for a variety of images.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("If you like, you can change the look of your photos with accessories available for cell phones. These include wide-angle lenses, fish-eye lenses, macros, and more!")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Photographs, whether found, altered, or created, should be stored in folders on your computer so you can find them. Always keep your originals safe and make copies to alter.")]), _vm._v(" "), _c('p', {
    staticClass: "tiph"
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("Create unique photos by covering the camera (or phone camera) lens with transparent and slightly opaque materials. Try organza, net, cheesecloth, dyed transparent fabric, tissue paper, bubble wrap, waxed paper, or plastic wrap. When I go out in my kayak, I take my phone zipped in a plastic bag. The plastic protects the camera and results in dreamy photos with a soft, painterly look.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Shoot both close up and from far away; you never know what will work for any given composition.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ChapTitle",
    attrs: {
      "id": "toc2"
    }
  }, [_vm._v("EDITING IMAGES")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Never before have we had so many opportunities to express ourselves digitally. There are many photo-editing programs and apps available that enable you to change, manipulate, and layer your original photographs. You can use your computer, your smartphone, or your tablet.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Computer Software")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Adobe Photoshop and Photoshop Elements are widely used and provide almost endless ways to work with digital images. There are also free programs that you can investigate, such as GIMP, Paint.NET, PicMonkey, and Pixlr.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Apps")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("The number of photo-editing apps for digital devices is amazing! Some are free, many cost just a bit, and a few are more expensive. Some do just one type of edit, while others offer many types of edits. Apps can enable you to change tone, add glow, blur, create a vintage look, try different filters, add edge treatments, and more. Apps can transform photographs into different art forms: Turn photos into drawings using Instant Sketch or Photosketcher or into watercolors using Waterlogue or Sketch Guru. Try Grungetastic to add a variety of textures (see Using Apps to Change a Photo).")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Explore Paper by FiftyThree, DrawCast, Sketch Club, ArtRage, Pixomatic, Draw Free for iPad, or Sketchbook Pro! See what you can find.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Social Sharing Sites")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Picasa, Tumblr, Instagram, Photofon, and Tadaa have photo-editing capabilities. Even photo storage programs such as iPhoto and Flickr have editing software—and the list keeps growing.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc3"
    }
  }, [_vm._v("Simple Ways to Transform Images")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Simple editing processes can enhance images and increase your success when printing, especially on unusual substrates. The emphasis is on experimentation. Don’t hesitate to try things out—you never know what you might find.")]), _vm._v(" "), _c('p', {
    staticClass: "tiph"
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("There are also many books, YouTube videos, and websites that provide specific information on software and techniques. Lynda.com is an excellent online learning resource for photography and other subjects.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('b', [_vm._v("Important!")]), _vm._v(" "), _c('i', [_vm._v("Always duplicate your original photo before editing or manipulating it.")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "toc4"
    }
  }, [_vm._v("CROPPING")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Cropping a photograph can draw more focus to the subject by eliminating extraneous details or busy backgrounds. Try different crops on an image. It’s often more interesting to place the focus of a photo off-center.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Stack of paper turned sideways")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "toc5"
    }
  }, [_vm._v("CHANGING HUE, VALUE, SATURATION, AND CONTRAST")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Editing a photo can create a better photo or a more creative image than just using a photograph directly off your camera or phone. Original images may simply need a shift in hue, value, saturation, or contrast for best printing.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Cropped and edited stack of paper. Editing included sharpening, increasing contrast, and increasing hue. Adjusting the sharpness increases clarity and detail for printing.")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_c('b', [_c('i', [_vm._v("Using Preview (Mac) to Change a Photo")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Original photo")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Adjusting the exposure can create the effect of having more or less light.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Increased exposure")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Using the contrast tool allows you to bring more black into the image adding highlights.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("High contrast")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Increasing the saturation increases the concentration of the colors within the photograph. Reducing the saturation takes color out of the image.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Full saturation")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Low saturation")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Adjusting the hue will change the tint of a photo within the range available on your program.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Hue adjusted toward blue tones")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Hue adjusted toward red tones")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Sepia")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_c('b', [_c('i', [_vm._v("Using Photoshop to Change a Photo")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("There are innumerable ways to change photos using Photoshop, Photoshop Elements, or other image-editing programs or apps. Just adjusting hue, value, saturation, and contrast can make a big difference.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Original image")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Increased contrast")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Reduced contrast")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Increasing the hue and/or saturation of the photo will make the colors more vivid.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Desaturation is a simple way to turn color photos to black and white. Some of the substrates you create will benefit from black-and-white images.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Decreased saturation turns photo to black and white")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Decreased saturation, lightened")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Decreased saturation with increased contrast")]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "toc6"
    }
  }, [_vm._v("PLAYING WITH FILTERS IN PHOTOSHOP")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Original image")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Changed to black and white")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Charcoal filter applied")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Plastic-wrap filter applied")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Stained-glass filter applied")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_c('b', [_c('i', [_vm._v("Using Apps to Change a Photo")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Look how four different apps can change a photo. Download some and play!")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("BeFunky")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Original photo")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Cyanotype effect")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Old photo effect")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Grungetastic")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Original photo")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Fun and interesting grunge effects")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Sketch Guru")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Original of a similar photo")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Pencil sketch")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("8-bit color")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Colored pencil")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Waterlogue")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Original photo")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("Fluid watercolor effects")]), _vm._v(" "), _c('p', {
    staticClass: "ChapTitle",
    attrs: {
      "id": "toc7"
    }
  }, [_vm._v("DIVIDING IMAGES FOR PRINTING")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Resize the image to the final desired size in nice, round numbers, such as 16˝ × 20˝, rather than 15.877˝ × 20.265˝. Select the desired resolution; for printing on fabric, around 180–200 PPI (pixels per inch) is fine.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Make sure the rulers are on.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Use the marquee tool to select a portion of the image that will fit on the page size you can print. For example, if you print 8½˝ × 11˝ pages, printing 8˝ × 10˝ portions will allow for seam allowances if you need to sew the pieces together.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg16_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Copy that portion and create a new document that is 8½˝ × 11˝ and the same PPI as your original photo. "), _c('b', [_vm._v("Note:")]), _vm._v(" "), _c('i', [_vm._v("You must match the PPI for this process to work.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Paste the copied portion into your new document and save it using a naming convention that identifies what part of the image it is, for example, Trees_Upper-Left.")]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Repeat as needed to print all the sections.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b987cad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_part02.vue
// module id = 69
// module chunks = 0